// data/PoliciesTableData.js
import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import DataTable from "examples/Tables/DataTable";
import Checkbox from "@mui/material/Checkbox";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";

function PoliciesTableData({ data, selectedIds, onToggle, onEdit, onDelete }) {
  const columns = [
    { Header: "", accessor: "checkbox", align: "center" },
    { Header: "Policy Number", accessor: "code", align: "left", width: "14%" },
    { Header: "Card ID", accessor: "cardNumber", align: "left" },
    { Header: "Employer", accessor: "employerName", align: "left" },
    { Header: "Effective Date", accessor: "effective", align: "left" },
    { Header: "Expiry Date", accessor: "expiry", align: "left" },
    { Header: "Status", accessor: "status", align: "left" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = (data || []).map((p) => ({
    checkbox: (
      <Checkbox size="small" checked={selectedIds.includes(p.id)} onChange={() => onToggle(p.id)} />
    ),
    code: (
      <MDTypography variant="caption" color="text" fontWeight="bold">
        {p.code}
      </MDTypography>
    ),
    cardNumber: (
      <MDTypography variant="caption" color="text">
        {p.cardNumber}
      </MDTypography>
    ),
    employerName: (
      <MDTypography variant="caption" color="text">
        {p.employerName}
      </MDTypography>
    ),
    effective: (
      <MDTypography variant="caption" color="text">
        {p.effectiveDatetime?.replace("T", " ")}
      </MDTypography>
    ),
    expiry: (
      <MDTypography variant="caption" color="text">
        {p.expiryDatetime?.replace("T", " ")}
      </MDTypography>
    ),
    status: (
      <MDBadge
        badgeContent={p.status}
        size="md"
        container
        color={p.status.toUpperCase() === "ACTIVE" ? "success" : "error"}
      />
    ),
    action: (
      <div>
        <IconButton size="small" onClick={() => onEdit(p)}>
          <Icon fontSize="small">edit</Icon>
        </IconButton>
        <IconButton size="small" color="error" onClick={() => onDelete(p)}>
          <Icon fontSize="small">delete</Icon>
        </IconButton>
      </div>
    ),
  }));

  return (
    <DataTable
      table={{ columns, rows }}
      isSorted={false}
      entriesPerPage={false}
      showTotalEntries={false}
      noEndBorder
      size="small"
    />
  );
}

PoliciesTableData.propTypes = {
  data: PropTypes.array.isRequired,
  selectedIds: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default PoliciesTableData;
